export default __webpack_public_path__ + "static/media/logo.d08b4507.svg";